export const NOTIFICATIONCONFIG = {
    INPUTLABEL: {
        DATE: 'Date',
        TIME: 'Time',
        DAILY: 'Daily',
        WEEKLY: 'Weekly',
        MONTHLY: 'Monthly',
        EVERY: 'Every',
        DAILY_DAYS: 'day(s)',
        EVERYWEEKDAY: 'Every Weekday',
        DAY: 'Day',
        OFEVERY: 'of every',
        MONTHS: 'month(s)',
        WEEKDAYS: {
            MONDAY: 'Monday',
            TUESDAY: 'Tuesday',
            WEDNESDAY: 'Wednesday',
            THURSDAY: 'Thursday',
            FRIDAY: 'Friday',
            SATURDAY: 'Saturday',
            SUNDAY: 'Sunday'
        }
    },
    FORMERRORMESSAGE: {
        DATEERROR: 'Please select notification start date.',
        TIMEERROR: 'Please select notification start time.',
        FREQUECYERROR: 'Please choose notification frequency.',
        DAILYFREQUENCYERROR: 'Please choose daily frequency.',
        DAYCOUNTERROR: 'Please fill days betweem 1 to 31.',
        MONTHCONTERROR: 'Please fill month between 1 to 12.',
        DAYERROR: 'Please fill days in numbers.',
        MONTHERROR: 'Please fill month in numbers.',
        WEEKERROR: 'Please select atleast 1 day.',
        MONTHLYERROR: 'Please choose  monthly frequency.',
    },
    INPUTVALUE: {
        DAILY: 'daily',
        WEEKLY: 'weekly',
        MONTHLY: 'monthly',
        EVERY: 'every',
        EVERYWEEKDAY: 'everyweekday',
        WEEKDAYS: {
            MONDAY: 'monday',
            TUESDAY: 'tuesday',
            WEDNESDAY: 'wednesday',
            THURSDAY: 'thursday',
            FRIDAY: 'friday',
            SATURDAY: 'saturday',
            SUNDAY: 'sunday'
        }
    },
    MSTEAMSCOPE: {
        PERSONAL: 'personal',
        CHANNEL: 'channel'
    },
    NOTIFICATIONNOTAVAILABLE: 'Add notifications via “Notify me” to view them in this tab.',
    NOTIFICATIONSCOPE: {
        PERSONAL: 'Personal',
        CHANNEL: 'Team',
        GROUP: 'Group',
    },
    QUERYPARAMSCOPE: {
        PERSONAL: 'personal',
        CHANNEL: 'channel',
        GROUP: 'groupChat'
    },
    NOTIFICATIONCONVERSATIONTYPE: {
        PERSONAL: 'personal',
        CHANNEL: 'channel',
        GROUP: 'groupChat'
    },
    NOTIFICATIONLIST: {
        TABLEHEADER: {
            SNO: 'S.No.',
            NAME: 'Notification Name',
            CREATEDBY: "Created By",
            SCOPE: 'Scope',
            CREATEDON: 'Created On',
            LASTDELIVERD: 'Last Delivered',
            ACTION: 'Action',
        },
        STATUS: {
            ENABLE: 'Enable',
            DISABLE: 'Disable'
        },
        ACTION: {
            EDIT: 'Edit',
            DELETE: 'Delete',
            VIEWCARD: 'View Card',
            CANCEL: 'Cancel',
            OK: 'Ok'
        },
        DELETEMESSAGE: 'Are you sure to delete?',
    }
}